// import { Component } from '@theme/component';
// import { fetchConfig, onAnimationEnd, preloadImage } from '@theme/utilities';
// import { ThemeEvents, CartAddEvent, CartErrorEvent, VariantUpdateEvent } from '@theme/events';
// import { cartPerformance } from '@theme/performance';
// import { morph } from '@theme/morph';

// export const ADD_TO_CART_TEXT_ANIMATION_DURATION = 2000;

// /**
//  * A custom element that manages an add to cart button.
//  */
// export class AddToCartComponent extends Component {
//   requiredRefs = ['addToCartButton'];

//   /** @type {number | undefined} */
//   #animationTimeout;

//   /** @type {number | undefined} */
//   #cleanupTimeout;

//   connectedCallback() {
//     super.connectedCallback();
//     this.addEventListener('pointerenter', this.#preloadImage);
//   }

//   disconnectedCallback() {
//     super.disconnectedCallback();
//     if (this.#animationTimeout) clearTimeout(this.#animationTimeout);
//     if (this.#cleanupTimeout) clearTimeout(this.#cleanupTimeout);
//     this.removeEventListener('pointerenter', this.#preloadImage);
//   }

//   disable() {
//     this.refs.addToCartButton.disabled = true;
//   }

//   enable() {
//     this.refs.addToCartButton.disabled = false;
//   }

//   handleClick(event) {
//     this.animateAddToCart();
//     if (!event.target.closest('.quick-add-modal')) this.#animateFlyToCart();
//   }

//   #preloadImage = () => {
//     const image = this.dataset.productVariantMedia;
//     if (!image) return;
//     preloadImage(image);
//   };

//   #animateFlyToCart() {
//     const { addToCartButton } = this.refs;
//     const cartIcon = document.querySelector('.header-actions__cart-icon');
//     const image = this.dataset.productVariantMedia;

//     if (!cartIcon || !addToCartButton || !image) return;

//     const flyToCartElement = /** @type {FlyToCart} */ (document.createElement('fly-to-cart'));
//     flyToCartElement.style.setProperty('background-image', `url(${image})`);
//     flyToCartElement.source = addToCartButton;
//     flyToCartElement.destination = cartIcon;
//     document.body.appendChild(flyToCartElement);
//   }

//   animateAddToCart() {
//     const { addToCartButton } = this.refs;

//     if (this.#animationTimeout) clearTimeout(this.#animationTimeout);
//     if (this.#cleanupTimeout) clearTimeout(this.#cleanupTimeout);

//     if (!addToCartButton.classList.contains('atc-added')) {
//       addToCartButton.classList.add('atc-added');
//     }

//     this.#animationTimeout = setTimeout(() => {
//       this.#cleanupTimeout = setTimeout(() => {
//         this.refs.addToCartButton.classList.remove('atc-added');
//       }, 10);
//     }, ADD_TO_CART_TEXT_ANIMATION_DURATION);
//   }
// }

// if (!customElements.get('add-to-cart-component')) {
//   customElements.define('add-to-cart-component', AddToCartComponent);
// }

// /**
//  * FIXED: Brand Model Selector Class with full functionality
//  */
// class BrandModelSelector {
//   constructor(form, brandModelData) {
//     this.form = form;
//     this.brandModelData = brandModelData || {};
//     this.initialized = false;
//     this.init();
//   }

//   init() {
//     if (!this.form || Object.keys(this.brandModelData).length === 0) {
//       console.warn('BrandModelSelector: Missing form or brand data');
//       return;
//     }

//     if (this.initialized || this.form.querySelector('#brandSelect')) {
//       console.log('BrandModelSelector: Already initialized');
//       return;
//     }

//     // Insert the HTML with modal functionality
//     this.form.insertAdjacentHTML('afterbegin', this.getBrandModelHTML());

//     // Setup elements and event listeners
//     this.setupElements();
//     this.populateBrandOptions();
//     this.setupEventListeners();
//     this.updateSubmitButtonState();
//     this.addModalStyles();
    
//     this.initialized = true;
//   }

//   getBrandModelHTML() {
//     return `
//       <div class="brand-model-selector">
//         <div class="form-group">
//           <label for="brandSelect">Select Brand:</label>
//           <div class="select-with-search">
//             <input type="text" id="brandSearch" placeholder="Search brands..." class="search-input" />
//             <div class="dropdown-container">
//               <select name="properties[Brand]" id="brandSelect" required>
//                 <option value="">--Select a Brand--</option>
//               </select>
//               <div class="dropdown-options" id="brandDropdown"></div>
//             </div>
//             <button type="button" id="addCustomBrand" class="custom-add-btn">+ Add Custom Brand</button>
//           </div>
//           <div class="error-message" id="brandError" style="display:none; color: red;">Please select a brand</div>
//         </div>
        
//         <div class="form-group">
//           <label for="modelSelect">Select Model:</label>
//           <div class="select-with-search">
//             <input type="text" id="modelSearch" placeholder="Search models..." class="search-input" disabled />
//             <div class="dropdown-container">
//               <select name="properties[Model]" id="modelSelect" required disabled>
//                 <option value="">--Select a Model--</option>
//               </select>
//               <div class="dropdown-options" id="modelDropdown"></div>
//             </div>
//             <button type="button" id="addCustomModel" class="custom-add-btn" disabled>+ Add Custom Model</button>
//           </div>
//           <div class="error-message" id="modelError" style="display:none; color: red;">Please select a model</div>
//         </div>

//         <!-- Custom Brand Modal -->
//         <div id="customBrandModal" class="custom-modal" style="display: none;">
//           <div class="modal-content">
//             <span class="close-modal">&times;</span>
//             <h3>Add Custom Brand</h3>
//             <div class="form-group">
//               <label for="customBrandInput">Brand Name:</label>
//               <input type="text" id="customBrandInput" placeholder="Enter brand name" />
//             </div>
//             <button type="button" id="saveCustomBrand" class="modal-btn">Add Brand</button>
//           </div>
//         </div>

//         <!-- Custom Model Modal -->
//         <div id="customModelModal" class="custom-modal" style="display: none;">
//           <div class="modal-content">
//             <span class="close-modal">&times;</span>
//             <h3>Add Custom Model</h3>
//             <div class="form-group">
//               <label for="customModelInput">Model Name:</label>
//               <input type="text" id="customModelInput" placeholder="Enter model name" />
//             </div>
//             <button type="button" id="saveCustomModel" class="modal-btn">Add Model</button>
//           </div>
//         </div>
//       </div>
//     `;
//   }

//   addModalStyles() {
//     if (document.querySelector('#brand-model-styles')) return;

//     const styles = document.createElement('style');
//     styles.id = 'brand-model-styles';
//     styles.textContent = `
//       .brand-model-selector {
//         margin-bottom: 20px;
//         padding: 15px;
//         border: 1px solid #e0e0e0;
//         border-radius: 5px;
//         background-color: #f9f9f9;
//       }

//       .form-group {
//         margin-bottom: 15px;
//       }

//       .form-group label {
//         display: block;
//         margin-bottom: 5px;
//         font-weight: bold;
//       }

//       .select-with-search {
//         position: relative;
//       }

//       .search-input {
//         width: 100%;
//         padding: 8px;
//         border: 1px solid #ccc;
//         border-radius: 4px;
//         margin-bottom: 5px;
//       }

//       .dropdown-container {
//         position: relative;
//       }

//       .dropdown-options {
//         position: absolute;
//         top: 100%;
//         left: 0;
//         right: 0;
//         background: white;
//         border: 1px solid #ccc;
//         border-top: none;
//         max-height: 200px;
//         overflow-y: auto;
//         z-index: 1000;
//         display: none;
//       }

//       .dropdown-options.show {
//         display: block;
//       }

//       .dropdown-item {
//         padding: 8px 12px;
//         cursor: pointer;
//         border-bottom: 1px solid #eee;
//       }

//       .dropdown-item:hover {
//         background-color: #f0f0f0;
//       }

//       .dropdown-item:last-child {
//         border-bottom: none;
//       }

//       .custom-add-btn {
//         margin-top: 5px;
//         padding: 8px 12px;
//         background: #007bff;
//         color: white;
//         border: none;
//         border-radius: 4px;
//         cursor: pointer;
//       }

//       .custom-add-btn:hover {
//         background: #0056b3;
//       }

//       .custom-add-btn:disabled {
//         background: #ccc;
//         cursor: not-allowed;
//       }

//       .custom-modal {
//         position: fixed;
//         top: 0;
//         left: 0;
//         width: 100%;
//         height: 100%;
//         background: rgba(0, 0, 0, 0.5);
//         display: flex;
//         justify-content: center;
//         align-items: center;
//         z-index: 2000;
//       }

//       .modal-content {
//         background: white;
//         padding: 20px;
//         border-radius: 8px;
//         width: 90%;
//         max-width: 400px;
//         position: relative;
//       }

//       .close-modal {
//         position: absolute;
//         top: 10px;
//         right: 15px;
//         font-size: 24px;
//         cursor: pointer;
//         color: #666;
//       }

//       .close-modal:hover {
//         color: #000;
//       }

//       .modal-btn {
//         padding: 10px 20px;
//         background: #28a745;
//         color: white;
//         border: none;
//         border-radius: 4px;
//         cursor: pointer;
//         width: 100%;
//         margin-top: 10px;
//       }

//       .modal-btn:hover {
//         background: #218838;
//       }

//       .no-results {
//         padding: 8px 12px;
//         color: #666;
//         font-style: italic;
//       }

//       .error-message {
//         color: red;
//         font-size: 14px;
//         margin-top: 5px;
//       }
//     `;
//     document.head.appendChild(styles);
//   }

//   setupElements() {
//     this.brandSelect = this.form.querySelector('#brandSelect');
//     this.modelSelect = this.form.querySelector('#modelSelect');
//     this.brandSearch = this.form.querySelector('#brandSearch');
//     this.modelSearch = this.form.querySelector('#modelSearch');
//     this.brandDropdown = this.form.querySelector('#brandDropdown');
//     this.modelDropdown = this.form.querySelector('#modelDropdown');
//     this.addCustomBrandBtn = this.form.querySelector('#addCustomBrand');
//     this.addCustomModelBtn = this.form.querySelector('#addCustomModel');
    
//     // Modal elements
//     this.customBrandModal = this.form.querySelector('#customBrandModal');
//     this.customModelModal = this.form.querySelector('#customModelModal');
//     this.customBrandInput = this.form.querySelector('#customBrandInput');
//     this.customModelInput = this.form.querySelector('#customModelInput');
//     this.saveCustomBrandBtn = this.form.querySelector('#saveCustomBrand');
//     this.saveCustomModelBtn = this.form.querySelector('#saveCustomModel');
//     this.closeModalBtns = this.form.querySelectorAll('.close-modal');
//   }

//   populateBrandOptions() {
//     this.clearOptions(this.brandSelect);
//     this.brandDropdown.innerHTML = '';
    
//     Object.keys(this.brandModelData).forEach(brand => {
//       const option = new Option(brand, brand);
//       this.brandSelect.add(option);
      
//       const item = document.createElement('div');
//       item.className = 'dropdown-item';
//       item.dataset.value = brand;
//       item.textContent = brand;
//       this.brandDropdown.appendChild(item);
//     });
//   }

//   setupEventListeners() {
//     // Search functionality
//     this.brandSearch.addEventListener('input', () => {
//       this.handleSearch(this.brandSearch, this.brandDropdown);
//       this.showDropdown(this.brandDropdown);
//     });

//     this.brandSearch.addEventListener('focus', () => {
//       this.showDropdown(this.brandDropdown);
//     });

//     this.modelSearch.addEventListener('input', () => {
//       this.handleSearch(this.modelSearch, this.modelDropdown);
//       this.showDropdown(this.modelDropdown);
//     });

//     this.modelSearch.addEventListener('focus', () => {
//       if (!this.modelSearch.disabled) {
//         this.showDropdown(this.modelDropdown);
//       }
//     });

//     // Dropdown selections
//     this.brandDropdown.addEventListener('click', (e) => {
//       this.selectDropdownItem(e, this.brandSelect, this.brandSearch);
//       this.hideDropdown(this.brandDropdown);
//     });

//     this.modelDropdown.addEventListener('click', (e) => {
//       this.selectDropdownItem(e, this.modelSelect, this.modelSearch);
//       this.hideDropdown(this.modelDropdown);
//     });

//     // Select changes
//     this.brandSelect.addEventListener('change', () => this.onBrandChange());
//     this.modelSelect.addEventListener('change', () => this.updateSubmitButtonState());

//     // Custom add buttons
//     this.addCustomBrandBtn.addEventListener('click', () => this.openModal(this.customBrandModal));
//     this.addCustomModelBtn.addEventListener('click', () => this.openModal(this.customModelModal));

//     // Modal save buttons
//     this.saveCustomBrandBtn.addEventListener('click', () => this.saveCustomBrand());
//     this.saveCustomModelBtn.addEventListener('click', () => this.saveCustomModel());

//     // Close modal buttons
//     this.closeModalBtns.forEach(btn => {
//       btn.addEventListener('click', (e) => {
//         const modal = e.target.closest('.custom-modal');
//         this.closeModal(modal);
//       });
//     });

//     // Close dropdowns when clicking outside
//     document.addEventListener('click', (e) => {
//       if (!e.target.closest('.select-with-search')) {
//         this.hideAllDropdowns();
//       }
//     });

//     // Close modals when clicking outside
//     document.addEventListener('click', (e) => {
//       if (e.target.classList.contains('custom-modal')) {
//         this.closeModal(e.target);
//       }
//     });
//   }

//   showDropdown(dropdown) {
//     dropdown.classList.add('show');
//   }

//   hideDropdown(dropdown) {
//     dropdown.classList.remove('show');
//   }

//   hideAllDropdowns() {
//     this.hideDropdown(this.brandDropdown);
//     this.hideDropdown(this.modelDropdown);
//   }

//   openModal(modal) {
//     modal.style.display = 'flex';
//     const input = modal.querySelector('input');
//     if (input) {
//       input.value = '';
//       setTimeout(() => input.focus(), 100);
//     }
//   }

//   closeModal(modal) {
//     modal.style.display = 'none';
//   }

//   handleSearch(input, dropdown) {
//     const term = input.value.toLowerCase();
//     const items = dropdown.querySelectorAll('.dropdown-item');
//     let hasVisibleItems = false;

//     // Remove existing "no results" message
//     const existingNoResults = dropdown.querySelector('.no-results');
//     if (existingNoResults) {
//       existingNoResults.remove();
//     }

//     items.forEach(item => {
//       const isVisible = item.textContent.toLowerCase().includes(term);
//       item.style.display = isVisible ? 'block' : 'none';
//       if (isVisible) hasVisibleItems = true;
//     });

//     // Add "no results" message if needed
//     if (!hasVisibleItems && term.length > 0) {
//       const noResultsEl = document.createElement('div');
//       noResultsEl.className = 'no-results';
//       noResultsEl.textContent = 'No matches found';
//       dropdown.appendChild(noResultsEl);
//     }
//   }

//   selectDropdownItem(e, select, search) {
//     const item = e.target.closest('.dropdown-item');
//     if (!item) return;
    
//     select.value = item.dataset.value;
//     search.value = item.textContent;
//     select.dispatchEvent(new Event('change', { bubbles: true }));
//   }

//   onBrandChange() {
//     const brand = this.brandSelect.value;
//     this.modelSelect.disabled = !brand;
//     this.modelSearch.disabled = !brand;
//     this.addCustomModelBtn.disabled = !brand;
    
//     // Clear model selection
//     this.modelSelect.value = '';
//     this.modelSearch.value = '';
    
//     // Hide brand error
//     const brandError = this.form.querySelector('#brandError');
//     if (brandError) brandError.style.display = 'none';
    
//     this.populateModelOptions(brand);
//     this.updateSubmitButtonState();
//   }

//   populateModelOptions(brand) {
//     this.clearOptions(this.modelSelect);
//     this.modelDropdown.innerHTML = '';
    
//     if (!brand || !this.brandModelData[brand]) return;
    
//     this.brandModelData[brand].forEach(model => {
//       const modelName = typeof model === 'string' ? model : model.name;
//       const option = new Option(modelName, modelName);
//       this.modelSelect.add(option);
      
//       const item = document.createElement('div');
//       item.className = 'dropdown-item';
//       item.dataset.value = modelName;
//       item.textContent = modelName;
//       this.modelDropdown.appendChild(item);
//     });
//   }

//   saveCustomBrand() {
//     const brandName = this.customBrandInput.value.trim();
    
//     if (!brandName) {
//       alert('Please enter a brand name');
//       return;
//     }
    
//     if (this.brandModelData[brandName]) {
//       alert('This brand already exists');
//       return;
//     }
    
//     // Add new brand
//     this.brandModelData[brandName] = [];
//     this.populateBrandOptions();
    
//     // Select the new brand
//     this.brandSelect.value = brandName;
//     this.brandSearch.value = brandName;
//     this.brandSelect.dispatchEvent(new Event('change', { bubbles: true }));
    
//     this.closeModal(this.customBrandModal);
//   }

//   saveCustomModel() {
//     const modelName = this.customModelInput.value.trim();
//     const selectedBrand = this.brandSelect.value;
    
//     if (!modelName) {
//       alert('Please enter a model name');
//       return;
//     }
    
//     if (!selectedBrand) {
//       alert('Please select a brand first');
//       return;
//     }
    
//     // Check if model exists
//     const modelExists = this.brandModelData[selectedBrand].some(model => {
//       const name = typeof model === 'string' ? model : model.name;
//       return name === modelName;
//     });
    
//     if (modelExists) {
//       alert('This model already exists for the selected brand');
//       return;
//     }
    
//     // Add new model
//     this.brandModelData[selectedBrand].push({ name: modelName });
//     this.populateModelOptions(selectedBrand);
    
//     // Select the new model
//     this.modelSelect.value = modelName;
//     this.modelSearch.value = modelName;
//     this.modelSelect.dispatchEvent(new Event('change', { bubbles: true }));
    
//     this.closeModal(this.customModelModal);
//   }

//   clearOptions(select) {
//     while (select.options.length > 1) {
//       select.remove(1);
//     }
//   }

//   updateSubmitButtonState() {
//     const btn = this.form.querySelector('[type="submit"]');
//     if (!btn) return;
    
//     const brandOk = this.brandSelect.value !== '';
//     const modelOk = this.modelSelect.value !== '';
    
//     if (brandOk && modelOk) {
//       btn.removeAttribute('disabled');
//     } else {
//       btn.setAttribute('disabled', 'true');
//     }
//   }

//   validateForm() {
//     let valid = true;
    
//     // Validate brand
//     if (!this.brandSelect.value) {
//       const brandError = this.form.querySelector('#brandError');
//       if (brandError) brandError.style.display = 'block';
//       valid = false;
//     }
    
//     // Validate model
//     if (!this.modelSelect.value) {
//       const modelError = this.form.querySelector('#modelError');
//       if (modelError) modelError.style.display = 'block';
//       valid = false;
//     }
    
//     return valid;
//   }
// }

// /**
//  * FIXED: ProductFormComponent - Always initialize BrandModelSelector
//  */
// class ProductFormComponent extends Component {
//   requiredRefs = ['variantId', 'liveRegion'];
//   #abortController = new AbortController();
//   #brandModelSelector = null;

//   /** @type {number | undefined} */
//   #timeout;

//   connectedCallback() {
//     super.connectedCallback();

//     // Always initialize BrandModelSelector when component connects
//     this.#initializeBrandModelSelector();
    
//     const { signal } = this.#abortController;
//     const target = this.closest('.shopify-section, dialog, product-card');
//     target?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate, { signal });
//     target?.addEventListener(ThemeEvents.variantSelected, this.#onVariantSelected, { signal });
//   }

//   disconnectedCallback() {
//     super.disconnectedCallback();
//     this.#abortController.abort();
//     this.#brandModelSelector = null;
//   }

//   #initializeBrandModelSelector() {
//     const form = this.querySelector('form');
//     if (form && !this.#brandModelSelector) {
//       // Use a slight delay to ensure DOM is ready
//       setTimeout(() => {
//         this.#brandModelSelector = new BrandModelSelector(form, window.brandModelData || {});
//       }, 100);
//     }
//   }

//   handleSubmit(event) {
//     const { addToCartTextError } = this.refs;
//     event.preventDefault();

//     if (this.#timeout) clearTimeout(this.#timeout);

//     if (this.refs.addToCartButtonContainer?.refs.addToCartButton?.getAttribute('disabled') === 'true') return;

//     const form = this.querySelector('form');
//     if (!form) throw new Error('Product form element missing');

//     // Validate brand/model selector if it exists
//     if (this.#brandModelSelector && !this.#brandModelSelector.validateForm()) {
//       return;
//     }

//     const formData = new FormData(form);

//     const cartItemsComponents = document.querySelectorAll('cart-items-component');
//     let cartItemComponentsSectionIds = [];
//     cartItemsComponents.forEach((item) => {
//       if (item instanceof HTMLElement && item.dataset.sectionId) {
//         cartItemComponentsSectionIds.push(item.dataset.sectionId);
//       }
//       formData.append('sections', cartItemComponentsSectionIds.join(','));
//     });

//     const fetchCfg = fetchConfig('javascript', { body: formData });

//     fetch(Theme.routes.cart_add_url, {
//       ...fetchCfg,
//       headers: {
//         ...fetchCfg.headers,
//         Accept: 'text/html',
//       },
//     })
//       .then((response) => response.json())
//       .then((response) => {
//         if (response.status) {
//           window.dispatchEvent(new CartErrorEvent(this.id, response.message));

//           if (!addToCartTextError) return;
//           addToCartTextError.classList.remove('hidden');

//           const textNode = addToCartTextError.childNodes[2];
//           if (textNode) {
//             textNode.textContent = response.message;
//           } else {
//             const newTextNode = document.createTextNode(response.message);
//             addToCartTextError.appendChild(newTextNode);
//           }

//           this.#setLiveRegionText(response.message);

//           this.#timeout = setTimeout(() => {
//             if (!addToCartTextError) return;
//             addToCartTextError.classList.add('hidden');
//             this.#clearLiveRegionText();
//           }, 10000);

//           this.dispatchEvent(
//             new CartAddEvent({}, this.id, {
//               didError: true,
//               source: 'product-form-component',
//               itemCount: Number(formData.get('quantity')) || Number(this.dataset.quantityDefault),
//               productId: this.dataset.productId,
//             })
//           );

//           return;
//         } else {
//           const id = formData.get('id');

//           if (addToCartTextError) {
//             addToCartTextError.classList.add('hidden');
//             addToCartTextError.removeAttribute('aria-live');
//           }

//           if (!id) throw new Error('Form ID is required');

//           if (this.refs.addToCartButtonContainer?.refs.addToCartButton) {
//             const addToCartButton = this.refs.addToCartButtonContainer.refs.addToCartButton;
//             const addedTextElement = addToCartButton.querySelector('.add-to-cart-text--added');
//             const addedText = addedTextElement?.textContent?.trim() || Theme.translations.added;

//             this.#setLiveRegionText(addedText);

//             setTimeout(() => {
//               this.#clearLiveRegionText();
//             }, 5000);
//           }

//           this.dispatchEvent(
//             new CartAddEvent({}, id.toString(), {
//               source: 'product-form-component',
//               itemCount: Number(formData.get('quantity')) || Number(this.dataset.quantityDefault),
//               productId: this.dataset.productId,
//               sections: response.sections,
//             })
//           );
//         }
//       })
//       .catch((error) => {
//         console.error(error);
//       })
//       .finally(() => {
//         cartPerformance.measureFromEvent('add:user-action', event);
//       });
//   }

//   #setLiveRegionText(text) {
//     const liveRegion = this.refs.liveRegion;
//     liveRegion.textContent = text;
//   }

//   #clearLiveRegionText() {
//     const liveRegion = this.refs.liveRegion;
//     liveRegion.textContent = '';
//   }

//   #onVariantUpdate = (event) => {
//     if (event.detail.data.newProduct) {
//       this.dataset.productId = event.detail.data.newProduct.id;
//     } else if (event.detail.data.productId !== this.dataset.productId) {
//       return;
//     }

//     const { variantId, addToCartButtonContainer } = this.refs;
//     const currentAddToCartButton = addToCartButtonContainer?.refs.addToCartButton;
//     const newAddToCartButton = event.detail.data.html.querySelector('[ref="addToCartButton"]');

//     if (!currentAddToCartButton) return;

//     if (event.detail.resource == null || event.detail.resource.available == false) {
//       addToCartButtonContainer.disable();
//       this.refs.acceleratedCheckoutButtonContainer?.setAttribute('hidden', 'true');
//     } else {
//       addToCartButtonContainer.enable();
//       this.refs.acceleratedCheckoutButtonContainer?.removeAttribute('hidden');
//     }

//     if (newAddToCartButton) {
//       morph(currentAddToCartButton, newAddToCartButton);
//     }

//     variantId.value = event.detail.resource.id ?? '';

//     if (event.detail.resource) {
//       const productVariantMedia = event.detail.resource.featured_media?.preview_image?.src;
//       productVariantMedia &&
//         addToCartButtonContainer?.setAttribute('data-product-variant-media', productVariantMedia + '&width=100');
//     }
//   };

//   #onVariantSelected = () => {
//     this.refs.addToCartButtonContainer?.disable();
//   };
// }

// if (!customElements.get('product-form-component')) {
//   customElements.define('product-form-component', ProductFormComponent);
// }

// // FlyToCart component remains the same
// class FlyToCart extends HTMLElement {
//   /** @type {Element} */
//   source;

//   /** @type {Element} */
//   destination;

//   connectedCallback() {
//     this.#animate();
//   }

//   #animate() {
//     const rect = this.getBoundingClientRect();
//     const sourceRect = this.source.getBoundingClientRect();
//     const destinationRect = this.destination.getBoundingClientRect();

//     const offset = {
//       x: rect.width / 2,
//       y: rect.height / 2,
//     };
//     const startPoint = {
//       x: sourceRect.left + sourceRect.width / 2 - offset.x,
//       y: sourceRect.top + sourceRect.height / 2 - offset.y,
//     };

//     const endPoint = {
//       x: destinationRect.left + destinationRect.width / 2 - offset.x,
//       y: destinationRect.top + destinationRect.height / 2 - offset.y,
//     };

//     const controlPoint1 = { x: startPoint.x, y: startPoint.y - 200 };
//     const controlPoint2 = { x: endPoint.x - 300, y: endPoint.y - 100 };

//     /** @type {number | null} */
//     let startTime = null;
//     const duration = 600;

//     this.style.opacity = '1';

//     const animate = (currentTime) => {
//       if (!startTime) startTime = currentTime;
//       const elapsed = currentTime - startTime;
//       const progress = Math.min(elapsed / duration, 1);

//       const position = bezierPoint(progress, startPoint, controlPoint1, controlPoint2, endPoint);

//       this.style.setProperty('--x', `${position.x}px`);
//       this.style.setProperty('--y', `${position.y}px`);

//       const scale = 1 - progress * 0.5;
//       this.style.setProperty('--scale', `${scale}`);

//       if (progress < 1) {
//         requestAnimationFrame(animate);
//       } else {
//         this.style.opacity = '0';
//         setTimeout(() => {
//           this.remove();
//         }, 200);
//       }
//     };

//     requestAnimationFrame(animate);
//   }
// }

// /**
//  * Bezier curve calculation for smooth animation
//  * @param {number} t - Progress from 0 to 1
//  * @param {Object} p0 - Start point {x, y}
//  * @param {Object} p1 - Control point 1 {x, y}
//  * @param {Object} p2 - Control point 2 {x, y}
//  * @param {Object} p3 - End point {x, y}
//  * @returns {Object} Current position {x, y}
//  */
// function bezierPoint(t, p0, p1, p2, p3) {
//   const u = 1 - t;
//   const tt = t * t;
//   const uu = u * u;
//   const uuu = uu * u;
//   const ttt = tt * t;

//   return {
//     x: uuu * p0.x + 3 * uu * t * p1.x + 3 * u * tt * p2.x + ttt * p3.x,
//     y: uuu * p0.y + 3 * uu * t * p1.y + 3 * u * tt * p2.y + ttt * p3.y,
//   };
// }

// // Register the FlyToCart custom element
// if (!customElements.get('fly-to-cart')) {
//   customElements.define('fly-to-cart', FlyToCart);
// }

// // Add required CSS for FlyToCart animation
// const flyToCartStyles = document.createElement('style');
// flyToCartStyles.textContent = `
//   fly-to-cart {
//     position: fixed;
//     top: 0;
//     left: 0;
//     width: 40px;
//     height: 40px;
//     border-radius: 50%;
//     background-size: cover;
//     background-position: center;
//     background-repeat: no-repeat;
//     border: 2px solid #fff;
//     box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
//     z-index: 9999;
//     pointer-events: none;
//     opacity: 0;
//     transform: translate3d(var(--x, 0), var(--y, 0), 0) scale(var(--scale, 1));
//     transition: opacity 0.2s ease-out;
//   }
// `;

// // Only add styles if they don't exist
// if (!document.querySelector('#fly-to-cart-styles')) {
// flyToCartStyles.id = 'fly-to-cart-styles';
//   document.head.appendChild(flyToCartStyles);
// }
// // window.brandModelData must be set externally (e.g., by data.js). No fallback or hardcoded data here.

// // Auto-initialize ProductFormComponent on page load
// document.addEventListener('DOMContentLoaded', () => {
//   const productForms = document.querySelectorAll('product-form-component');
//   productForms.forEach(form => {
//     if (!form.initialized) {
//       form.initialized = true;
//     }
//   });
// });

// // Export for module usage
// export { BrandModelSelector, ProductFormComponent, FlyToCart, bezierPoint };
import { Component } from '@theme/component';
import { fetchConfig, onAnimationEnd, preloadImage } from '@theme/utilities';
import { ThemeEvents, CartAddEvent, CartErrorEvent, VariantUpdateEvent } from '@theme/events';
import { cartPerformance } from '@theme/performance';
import { morph } from '@theme/morph';

export const ADD_TO_CART_TEXT_ANIMATION_DURATION = 2000;

/**
 * A custom element that manages an add to cart button.
 */
export class AddToCartComponent extends Component {
  requiredRefs = ['addToCartButton'];

  /** @type {number | undefined} */
  #animationTimeout;

  /** @type {number | undefined} */
  #cleanupTimeout;

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('pointerenter', this.#preloadImage);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.#animationTimeout) clearTimeout(this.#animationTimeout);
    if (this.#cleanupTimeout) clearTimeout(this.#cleanupTimeout);
    this.removeEventListener('pointerenter', this.#preloadImage);
  }

  disable() {
    this.refs.addToCartButton.disabled = true;
  }

  enable() {
    this.refs.addToCartButton.disabled = false;
  }

  handleClick(event) {
    this.animateAddToCart();
    if (!event.target.closest('.quick-add-modal')) this.#animateFlyToCart();
  }

  #preloadImage = () => {
    const image = this.dataset.productVariantMedia;
    if (!image) return;
    preloadImage(image);
  };

  #animateFlyToCart() {
    const { addToCartButton } = this.refs;
    const cartIcon = document.querySelector('.header-actions__cart-icon');
    const image = this.dataset.productVariantMedia;

    if (!cartIcon || !addToCartButton || !image) return;

    const flyToCartElement = /** @type {FlyToCart} */ (document.createElement('fly-to-cart'));
    flyToCartElement.style.setProperty('background-image', `url(${image})`);
    flyToCartElement.source = addToCartButton;
    flyToCartElement.destination = cartIcon;
    document.body.appendChild(flyToCartElement);
  }

  animateAddToCart() {
    const { addToCartButton } = this.refs;

    if (this.#animationTimeout) clearTimeout(this.#animationTimeout);
    if (this.#cleanupTimeout) clearTimeout(this.#cleanupTimeout);

    if (!addToCartButton.classList.contains('atc-added')) {
      addToCartButton.classList.add('atc-added');
    }

    this.#animationTimeout = setTimeout(() => {
      this.#cleanupTimeout = setTimeout(() => {
        this.refs.addToCartButton.classList.remove('atc-added');
      }, 10);
    }, ADD_TO_CART_TEXT_ANIMATION_DURATION);
  }
}

if (!customElements.get('add-to-cart-component')) {
  customElements.define('add-to-cart-component', AddToCartComponent);
}

/**
 * FIXED: Brand Model Selector Class with full functionality
 */
class BrandModelSelector {
  constructor(form, brandModelData) {
    this.form = form;
    this.brandModelData = brandModelData || {};
    this.initialized = false;
    this.init();
  }

  init() {
    if (!this.form || Object.keys(this.brandModelData).length === 0) {
      console.warn('BrandModelSelector: Missing form or brand data');
      return;
    }

    if (this.initialized || this.form.querySelector('#brandSelect')) {
      console.log('BrandModelSelector: Already initialized');
      return;
    }

    // Insert the HTML with modal functionality
    this.form.insertAdjacentHTML('afterbegin', this.getBrandModelHTML());

    // Setup elements and event listeners
    this.setupElements();
    this.populateBrandOptions();
    this.setupEventListeners();
    this.updateSubmitButtonState();
    this.addModalStyles();
    
    this.initialized = true;
  }

  getBrandModelHTML() {
    return `
      <div class="brand-model-selector">
        <div class="form-group">
          <label for="brandSelect">Select Brand:</label>
          <div class="select-with-search">
            <input type="text" id="brandSearch" placeholder="Search brands..." class="search-input" />
            <div class="dropdown-container">
              <select name="properties[Brand]" id="brandSelect" required>
                <option value="">--Select a Brand--</option>
              </select>
              <div class="dropdown-options" id="brandDropdown"></div>
            </div>
            <button type="button" id="addCustomBrand" class="custom-add-btn">+ Add Custom Brand</button>
          </div>
          <div class="error-message" id="brandError" style="display:none; color: red;">Please select a brand</div>
        </div>
        
        <div class="form-group">
          <label for="modelSelect">Select Model:</label>
          <div class="select-with-search">
            <input type="text" id="modelSearch" placeholder="Search models..." class="search-input" disabled />
            <div class="dropdown-container">
              <select name="properties[Model]" id="modelSelect" required disabled>
                <option value="">--Select a Model--</option>
              </select>
              <div class="dropdown-options" id="modelDropdown"></div>
            </div>
            <button type="button" id="addCustomModel" class="custom-add-btn" disabled>+ Add Custom Model</button>
          </div>
          <div class="error-message" id="modelError" style="display:none; color: red;">Please select a model</div>
        </div>

        <!-- Custom Brand Modal -->
        <div id="customBrandModal" class="custom-modal" style="display: none;">
          <div class="modal-content">
            <span class="close-modal">&times;</span>
            <h3>Add Custom Brand</h3>
            <div class="form-group">
              <label for="customBrandInput">Brand Name:</label>
              <input type="text" id="customBrandInput" placeholder="Enter brand name" />
            </div>
            <button type="button" id="saveCustomBrand" class="modal-btn">Add Brand</button>
          </div>
        </div>

        <!-- Custom Model Modal -->
        <div id="customModelModal" class="custom-modal" style="display: none;">
          <div class="modal-content">
            <span class="close-modal">&times;</span>
            <h3>Add Custom Model</h3>
            <div class="form-group">
              <label for="customModelInput">Model Name:</label>
              <input type="text" id="customModelInput" placeholder="Enter model name" />
            </div>
            <button type="button" id="saveCustomModel" class="modal-btn">Add Model</button>
          </div>
        </div>
      </div>
    `;
  }

  addModalStyles() {
    if (document.querySelector('#brand-model-styles')) return;

    const styles = document.createElement('style');
    styles.id = 'brand-model-styles';
    styles.textContent = `
      .brand-model-selector {
        margin-bottom: 20px;
        padding: 15px;
        border: 1px solid #e0e0e0;
        border-radius: 5px;
        background-color: #f9f9f9;
      }

      .form-group {
        margin-bottom: 15px;
      }

      .form-group label {
        display: block;
        margin-bottom: 5px;
        font-weight: bold;
      }

      .select-with-search {
        position: relative;
      }

      .search-input {
        width: 100%;
        padding: 8px;
        border: 1px solid #ccc;
        border-radius: 4px;
        margin-bottom: 5px;
      }

      .dropdown-container {
        position: relative;
      }

      .dropdown-options {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: white;
        border: 1px solid #ccc;
        border-top: none;
        max-height: 200px;
        overflow-y: auto;
        z-index: 1000;
        display: none;
      }

      .dropdown-options.show {
        display: block;
      }

      .dropdown-item {
        padding: 8px 12px;
        cursor: pointer;
        border-bottom: 1px solid #eee;
      }

      .dropdown-item:hover {
        background-color: #f0f0f0;
      }

      .dropdown-item:last-child {
        border-bottom: none;
      }

      .custom-add-btn {
        margin-top: 5px;
        padding: 8px 12px;
        background: #007bff;
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
      }

      .custom-add-btn:hover {
        background: #0056b3;
      }

      .custom-add-btn:disabled {
        background: #ccc;
        cursor: not-allowed;
      }

      .custom-modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2000;
      }

      .modal-content {
        background: white;
        padding: 20px;
        border-radius: 8px;
        width: 90%;
        max-width: 400px;
        position: relative;
      }

      .close-modal {
        position: absolute;
        top: 10px;
        right: 15px;
        font-size: 24px;
        cursor: pointer;
        color: #666;
      }

      .close-modal:hover {
        color: #000;
      }

      .modal-btn {
        padding: 10px 20px;
        background: #28a745;
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        width: 100%;
        margin-top: 10px;
      }

      .modal-btn:hover {
        background: #218838;
      }

      .no-results {
        padding: 8px 12px;
        color: #666;
        font-style: italic;
      }

      .error-message {
        color: red;
        font-size: 14px;
        margin-top: 5px;
      }
    `;
    document.head.appendChild(styles);
  }

  setupElements() {
    this.brandSelect = this.form.querySelector('#brandSelect');
    this.modelSelect = this.form.querySelector('#modelSelect');
    this.brandSearch = this.form.querySelector('#brandSearch');
    this.modelSearch = this.form.querySelector('#modelSearch');
    this.brandDropdown = this.form.querySelector('#brandDropdown');
    this.modelDropdown = this.form.querySelector('#modelDropdown');
    this.addCustomBrandBtn = this.form.querySelector('#addCustomBrand');
    this.addCustomModelBtn = this.form.querySelector('#addCustomModel');
    
    // Modal elements
    this.customBrandModal = this.form.querySelector('#customBrandModal');
    this.customModelModal = this.form.querySelector('#customModelModal');
    this.customBrandInput = this.form.querySelector('#customBrandInput');
    this.customModelInput = this.form.querySelector('#customModelInput');
    this.saveCustomBrandBtn = this.form.querySelector('#saveCustomBrand');
    this.saveCustomModelBtn = this.form.querySelector('#saveCustomModel');
    this.closeModalBtns = this.form.querySelectorAll('.close-modal');
  }

  populateBrandOptions() {
    this.clearOptions(this.brandSelect);
    this.brandDropdown.innerHTML = '';
    
    Object.keys(this.brandModelData).forEach(brand => {
      const option = new Option(brand, brand);
      this.brandSelect.add(option);
      
      const item = document.createElement('div');
      item.className = 'dropdown-item';
      item.dataset.value = brand;
      item.textContent = brand;
      this.brandDropdown.appendChild(item);
    });
  }

  setupEventListeners() {
    // Search functionality
    this.brandSearch.addEventListener('input', () => {
      this.handleSearch(this.brandSearch, this.brandDropdown);
      this.showDropdown(this.brandDropdown);
    });

    this.brandSearch.addEventListener('focus', () => {
      this.showDropdown(this.brandDropdown);
    });

    this.modelSearch.addEventListener('input', () => {
      this.handleSearch(this.modelSearch, this.modelDropdown);
      this.showDropdown(this.modelDropdown);
    });

    this.modelSearch.addEventListener('focus', () => {
      if (!this.modelSearch.disabled) {
        this.showDropdown(this.modelDropdown);
      }
    });

    // Dropdown selections
    this.brandDropdown.addEventListener('click', (e) => {
      this.selectDropdownItem(e, this.brandSelect, this.brandSearch);
      this.hideDropdown(this.brandDropdown);
    });

    this.modelDropdown.addEventListener('click', (e) => {
      this.selectDropdownItem(e, this.modelSelect, this.modelSearch);
      this.hideDropdown(this.modelDropdown);
    });

    // Select changes
    this.brandSelect.addEventListener('change', () => this.onBrandChange());
    this.modelSelect.addEventListener('change', () => this.updateSubmitButtonState());

    // Custom add buttons
    this.addCustomBrandBtn.addEventListener('click', () => this.openModal(this.customBrandModal));
    this.addCustomModelBtn.addEventListener('click', () => this.openModal(this.customModelModal));

    // Modal save buttons
    this.saveCustomBrandBtn.addEventListener('click', () => this.saveCustomBrand());
    this.saveCustomModelBtn.addEventListener('click', () => this.saveCustomModel());

    // Close modal buttons
    this.closeModalBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const modal = e.target.closest('.custom-modal');
        this.closeModal(modal);
      });
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.select-with-search')) {
        this.hideAllDropdowns();
      }
    });

    // Close modals when clicking outside
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('custom-modal')) {
        this.closeModal(e.target);
      }
    });
  }

  showDropdown(dropdown) {
    dropdown.classList.add('show');
  }

  hideDropdown(dropdown) {
    dropdown.classList.remove('show');
  }

  hideAllDropdowns() {
    this.hideDropdown(this.brandDropdown);
    this.hideDropdown(this.modelDropdown);
  }

  openModal(modal) {
    modal.style.display = 'flex';
    const input = modal.querySelector('input');
    if (input) {
      input.value = '';
      setTimeout(() => input.focus(), 100);
    }
  }

  closeModal(modal) {
    modal.style.display = 'none';
  }

  handleSearch(input, dropdown) {
    const term = input.value.toLowerCase();
    const items = dropdown.querySelectorAll('.dropdown-item');
    let hasVisibleItems = false;

    // Remove existing "no results" message
    const existingNoResults = dropdown.querySelector('.no-results');
    if (existingNoResults) {
      existingNoResults.remove();
    }

    items.forEach(item => {
      const isVisible = item.textContent.toLowerCase().includes(term);
      item.style.display = isVisible ? 'block' : 'none';
      if (isVisible) hasVisibleItems = true;
    });

    // Add "no results" message if needed
    if (!hasVisibleItems && term.length > 0) {
      const noResultsEl = document.createElement('div');
      noResultsEl.className = 'no-results';
      noResultsEl.textContent = 'No matches found';
      dropdown.appendChild(noResultsEl);
    }
  }

  selectDropdownItem(e, select, search) {
    const item = e.target.closest('.dropdown-item');
    if (!item) return;
    
    select.value = item.dataset.value;
    search.value = item.textContent;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  onBrandChange() {
    const brand = this.brandSelect.value;
    this.modelSelect.disabled = !brand;
    this.modelSearch.disabled = !brand;
    this.addCustomModelBtn.disabled = !brand;
    
    // Clear model selection
    this.modelSelect.value = '';
    this.modelSearch.value = '';
    
    // Hide brand error
    const brandError = this.form.querySelector('#brandError');
    if (brandError) brandError.style.display = 'none';
    
    this.populateModelOptions(brand);
    this.updateSubmitButtonState();
  }

  populateModelOptions(brand) {
    this.clearOptions(this.modelSelect);
    this.modelDropdown.innerHTML = '';
    
    if (!brand || !this.brandModelData[brand]) return;
    
    this.brandModelData[brand].forEach(model => {
      const modelName = typeof model === 'string' ? model : model.name;
      const option = new Option(modelName, modelName);
      this.modelSelect.add(option);
      
      const item = document.createElement('div');
      item.className = 'dropdown-item';
      item.dataset.value = modelName;
      item.textContent = modelName;
      this.modelDropdown.appendChild(item);
    });
  }

  saveCustomBrand() {
    const brandName = this.customBrandInput.value.trim();
    
    if (!brandName) {
      alert('Please enter a brand name');
      return;
    }
    
    if (this.brandModelData[brandName]) {
      alert('This brand already exists');
      return;
    }
    
    // Add new brand
    this.brandModelData[brandName] = [];
    this.populateBrandOptions();
    
    // Select the new brand
    this.brandSelect.value = brandName;
    this.brandSearch.value = brandName;
    this.brandSelect.dispatchEvent(new Event('change', { bubbles: true }));
    
    this.closeModal(this.customBrandModal);
  }

  saveCustomModel() {
    const modelName = this.customModelInput.value.trim();
    const selectedBrand = this.brandSelect.value;
    
    if (!modelName) {
      alert('Please enter a model name');
      return;
    }
    
    if (!selectedBrand) {
      alert('Please select a brand first');
      return;
    }
    
    // Check if model exists
    const modelExists = this.brandModelData[selectedBrand].some(model => {
      const name = typeof model === 'string' ? model : model.name;
      return name === modelName;
    });
    
    if (modelExists) {
      alert('This model already exists for the selected brand');
      return;
    }
    
    // Add new model
    this.brandModelData[selectedBrand].push({ name: modelName });
    this.populateModelOptions(selectedBrand);
    
    // Select the new model
    this.modelSelect.value = modelName;
    this.modelSearch.value = modelName;
    this.modelSelect.dispatchEvent(new Event('change', { bubbles: true }));
    
    this.closeModal(this.customModelModal);
  }

  clearOptions(select) {
    while (select.options.length > 1) {
      select.remove(1);
    }
  }

  updateSubmitButtonState() {
    const btn = this.form.querySelector('[type="submit"]');
    if (!btn) return;
    
    const brandOk = this.brandSelect.value !== '';
    const modelOk = this.modelSelect.value !== '';
    
    if (brandOk && modelOk) {
      btn.removeAttribute('disabled');
    } else {
      btn.setAttribute('disabled', 'true');
    }
  }

  validateForm() {
    let valid = true;
    
    // Validate brand
    if (!this.brandSelect.value) {
      const brandError = this.form.querySelector('#brandError');
      if (brandError) brandError.style.display = 'block';
      valid = false;
    }
    
    // Validate model
    if (!this.modelSelect.value) {
      const modelError = this.form.querySelector('#modelError');
      if (modelError) modelError.style.display = 'block';
      valid = false;
    }
    
    return valid;
  }
}

/**
 * FIXED: ProductFormComponent - Always initialize BrandModelSelector
 */
class ProductFormComponent extends Component {
  requiredRefs = ['variantId', 'liveRegion'];
  #abortController = new AbortController();
  #brandModelSelector = null;

  /** @type {number | undefined} */
  #timeout;

  connectedCallback() {
    super.connectedCallback();

    // Always initialize BrandModelSelector when component connects
    this.#initializeBrandModelSelector();
    
    const { signal } = this.#abortController;
    const target = this.closest('.shopify-section, dialog, product-card');
    target?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate, { signal });
    target?.addEventListener(ThemeEvents.variantSelected, this.#onVariantSelected, { signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
    this.#brandModelSelector = null;
  }

  #initializeBrandModelSelector() {
    const form = this.querySelector('form');
    if (form && !this.#brandModelSelector) {
      // Try to initialize with retry mechanism
      this.#tryInitialize(form);
    }
  }

  #tryInitialize(form, attempts = 0) {
    const maxAttempts = 10; // Will try for 5 seconds (10 attempts * 500ms)
    
    if (window.brandModelData && Object.keys(window.brandModelData).length > 0) {
      // Data is available, initialize
      this.#brandModelSelector = new BrandModelSelector(form, window.brandModelData);
      console.log('BrandModelSelector initialized successfully');
    } else if (attempts < maxAttempts) {
      // Data not available yet, retry after 500ms
      console.log(`Waiting for brandModelData... Attempt ${attempts + 1}/${maxAttempts}`);
      setTimeout(() => {
        this.#tryInitialize(form, attempts + 1);
      }, 500);
    } else {
      // Give up after max attempts
      console.error('Failed to initialize BrandModelSelector: brandModelData not available after multiple attempts');
    }
  }

  handleSubmit(event) {
    const { addToCartTextError } = this.refs;
    event.preventDefault();

    if (this.#timeout) clearTimeout(this.#timeout);

    if (this.refs.addToCartButtonContainer?.refs.addToCartButton?.getAttribute('disabled') === 'true') return;

    const form = this.querySelector('form');
    if (!form) throw new Error('Product form element missing');

    // Validate brand/model selector if it exists
    if (this.#brandModelSelector && !this.#brandModelSelector.validateForm()) {
      return;
    }

    const formData = new FormData(form);

    const cartItemsComponents = document.querySelectorAll('cart-items-component');
    let cartItemComponentsSectionIds = [];
    cartItemsComponents.forEach((item) => {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        cartItemComponentsSectionIds.push(item.dataset.sectionId);
      }
      formData.append('sections', cartItemComponentsSectionIds.join(','));
    });

    const fetchCfg = fetchConfig('javascript', { body: formData });

    fetch(Theme.routes.cart_add_url, {
      ...fetchCfg,
      headers: {
        ...fetchCfg.headers,
        Accept: 'text/html',
      },
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          window.dispatchEvent(new CartErrorEvent(this.id, response.message));

          if (!addToCartTextError) return;
          addToCartTextError.classList.remove('hidden');

          const textNode = addToCartTextError.childNodes[2];
          if (textNode) {
            textNode.textContent = response.message;
          } else {
            const newTextNode = document.createTextNode(response.message);
            addToCartTextError.appendChild(newTextNode);
          }

          this.#setLiveRegionText(response.message);

          this.#timeout = setTimeout(() => {
            if (!addToCartTextError) return;
            addToCartTextError.classList.add('hidden');
            this.#clearLiveRegionText();
          }, 10000);

          this.dispatchEvent(
            new CartAddEvent({}, this.id, {
              didError: true,
              source: 'product-form-component',
              itemCount: Number(formData.get('quantity')) || Number(this.dataset.quantityDefault),
              productId: this.dataset.productId,
            })
          );

          return;
        } else {
          const id = formData.get('id');

          if (addToCartTextError) {
            addToCartTextError.classList.add('hidden');
            addToCartTextError.removeAttribute('aria-live');
          }

          if (!id) throw new Error('Form ID is required');

          if (this.refs.addToCartButtonContainer?.refs.addToCartButton) {
            const addToCartButton = this.refs.addToCartButtonContainer.refs.addToCartButton;
            const addedTextElement = addToCartButton.querySelector('.add-to-cart-text--added');
            const addedText = addedTextElement?.textContent?.trim() || Theme.translations.added;

            this.#setLiveRegionText(addedText);

            setTimeout(() => {
              this.#clearLiveRegionText();
            }, 5000);
          }

          this.dispatchEvent(
            new CartAddEvent({}, id.toString(), {
              source: 'product-form-component',
              itemCount: Number(formData.get('quantity')) || Number(this.dataset.quantityDefault),
              productId: this.dataset.productId,
              sections: response.sections,
            })
          );
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        cartPerformance.measureFromEvent('add:user-action', event);
      });
  }

  #setLiveRegionText(text) {
    const liveRegion = this.refs.liveRegion;
    liveRegion.textContent = text;
  }

  #clearLiveRegionText() {
    const liveRegion = this.refs.liveRegion;
    liveRegion.textContent = '';
  }

  #onVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.detail.data.productId !== this.dataset.productId) {
      return;
    }

    const { variantId, addToCartButtonContainer } = this.refs;
    const currentAddToCartButton = addToCartButtonContainer?.refs.addToCartButton;
    const newAddToCartButton = event.detail.data.html.querySelector('[ref="addToCartButton"]');

    if (!currentAddToCartButton) return;

    if (event.detail.resource == null || event.detail.resource.available == false) {
      addToCartButtonContainer.disable();
      this.refs.acceleratedCheckoutButtonContainer?.setAttribute('hidden', 'true');
    } else {
      addToCartButtonContainer.enable();
      this.refs.acceleratedCheckoutButtonContainer?.removeAttribute('hidden');
    }

    if (newAddToCartButton) {
      morph(currentAddToCartButton, newAddToCartButton);
    }

    variantId.value = event.detail.resource.id ?? '';

    if (event.detail.resource) {
      const productVariantMedia = event.detail.resource.featured_media?.preview_image?.src;
      productVariantMedia &&
        addToCartButtonContainer?.setAttribute('data-product-variant-media', productVariantMedia + '&width=100');
    }
  };

  #onVariantSelected = () => {
    this.refs.addToCartButtonContainer?.disable();
  };
}

if (!customElements.get('product-form-component')) {
  customElements.define('product-form-component', ProductFormComponent);
}

// FlyToCart component remains the same
class FlyToCart extends HTMLElement {
  /** @type {Element} */
  source;

  /** @type {Element} */
  destination;

  connectedCallback() {
    this.#animate();
  }

  #animate() {
    const rect = this.getBoundingClientRect();
    const sourceRect = this.source.getBoundingClientRect();
    const destinationRect = this.destination.getBoundingClientRect();

    const offset = {
      x: rect.width / 2,
      y: rect.height / 2,
    };
    const startPoint = {
      x: sourceRect.left + sourceRect.width / 2 - offset.x,
      y: sourceRect.top + sourceRect.height / 2 - offset.y,
    };

    const endPoint = {
      x: destinationRect.left + destinationRect.width / 2 - offset.x,
      y: destinationRect.top + destinationRect.height / 2 - offset.y,
    };

    const controlPoint1 = { x: startPoint.x, y: startPoint.y - 200 };
    const controlPoint2 = { x: endPoint.x - 300, y: endPoint.y - 100 };

    /** @type {number | null} */
    let startTime = null;
    const duration = 600;

    this.style.opacity = '1';

    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      const position = bezierPoint(progress, startPoint, controlPoint1, controlPoint2, endPoint);

      this.style.setProperty('--x', `${position.x}px`);
      this.style.setProperty('--y', `${position.y}px`);

      const scale = 1 - progress * 0.5;
      this.style.setProperty('--scale', `${scale}`);

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        this.style.opacity = '0';
        setTimeout(() => {
          this.remove();
        }, 200);
      }
    };

    requestAnimationFrame(animate);
  }
}

/**
 * Bezier curve calculation for smooth animation
 * @param {number} t - Progress from 0 to 1
 * @param {Object} p0 - Start point {x, y}
 * @param {Object} p1 - Control point 1 {x, y}
 * @param {Object} p2 - Control point 2 {x, y}
 * @param {Object} p3 - End point {x, y}
 * @returns {Object} Current position {x, y}
 */
function bezierPoint(t, p0, p1, p2, p3) {
  const u = 1 - t;
  const tt = t * t;
  const uu = u * u;
  const uuu = uu * u;
  const ttt = tt * t;

  return {
    x: uuu * p0.x + 3 * uu * t * p1.x + 3 * u * tt * p2.x + ttt * p3.x,
    y: uuu * p0.y + 3 * uu * t * p1.y + 3 * u * tt * p2.y + ttt * p3.y,
  };
}

// Register the FlyToCart custom element
if (!customElements.get('fly-to-cart')) {
  customElements.define('fly-to-cart', FlyToCart);
}

// Add required CSS for FlyToCart animation
const flyToCartStyles = document.createElement('style');
flyToCartStyles.textContent = `
  fly-to-cart {
    position: fixed;
    top: 0;
    left: 0;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border: 2px solid #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    z-index: 9999;
    pointer-events: none;
    opacity: 0;
    transform: translate3d(var(--x, 0), var(--y, 0), 0) scale(var(--scale, 1));
    transition: opacity 0.2s ease-out;
  }
`;

// Only add styles if they don't exist
if (!document.querySelector('#fly-to-cart-styles')) {
flyToCartStyles.id = 'fly-to-cart-styles';
  document.head.appendChild(flyToCartStyles);
}
// window.brandModelData must be set externally (e.g., by data.js). No fallback or hardcoded data here.

// Auto-initialize ProductFormComponent on page load
document.addEventListener('DOMContentLoaded', () => {
  const productForms = document.querySelectorAll('product-form-component');
  productForms.forEach(form => {
    if (!form.initialized) {
      form.initialized = true;
    }
  });
});

// Export for module usage
export { BrandModelSelector, ProductFormComponent, FlyToCart, bezierPoint };